import React from 'react';
import DataTable from 'react-data-table-component';
import '../../../libs/css/dataTable.css';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    Tooltip, Legend, ResponsiveContainer,
} from 'recharts';

function SubCountReportTable({ dataList, isLoading, isFade, totalCount, reportType, onExportCSV }) {

    const columns = [
        {
            name: 'Period',
            selector: row => row.period,
            sortable: true,
            grow: 2,
        },
        {
            name: 'Count',
            selector: row => parseFloat(row.count).toLocaleString(),
            sortable: true,
        },
    ];

    // Trim long period labels for the chart x-axis
    const chartData = dataList.map(row => ({
        period: row.period.length > 14 ? row.period.slice(0, 14) + '…' : row.period,
        count: parseFloat(row.count),
    }));

    if (isLoading || isFade) return <LoadingSpinner />;

    if (dataList.length === 0) {
        return (
            <div className="card">
                <div className="card-body text-center p-5">
                    <h5>No data to display</h5>
                    <p>Select filters above and click Filter to load data.</p>
                </div>
            </div>
        );
    }

    return (
        <div>
            {/* Summary cards */}
            <div className="row mt-3 mb-3">
                <div className="col-md-4">
                    <div className="card bg-primary text-white">
                        <div className="card-body">
                            <h5 className="card-title">Total Count</h5>
                            <h3>{parseFloat(totalCount).toLocaleString()}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card bg-info text-white">
                        <div className="card-body">
                            <h5 className="card-title">Report Type</h5>
                            <h3 style={{ textTransform: 'capitalize' }}>{reportType}</h3>
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="card bg-success text-white">
                        <div className="card-body">
                            <h5 className="card-title">Periods</h5>
                            <h3>{dataList.length}</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Export button */}
            <div className="row mb-3">
                <div className="col-md-12 text-right">
                    <button className="btn btn-success" onClick={onExportCSV}>
                        <i className="fa fa-file-excel-o"></i> Export to CSV
                    </button>
                </div>
            </div>

            {/* Data table */}
            <div style={{ opacity: isFade ? 0.3 : 1 }}>
                <DataTable
                    className="services_datatable users"
                    columns={columns}
                    data={dataList}
                    highlightOnHover
                    striped
                    pagination
                    paginationPerPage={20}
                    paginationComponentOptions={{ noRowsPerPage: true }}
                />
            </div>

            {/* Bar chart */}
            <div className="card mt-4 mb-4">
                <div className="card-header">
                    <h5>Count Trend</h5>
                </div>
                <div className="card-body">
                    <div style={{ width: '100%', height: 350 }}>
                        <ResponsiveContainer>
                            <BarChart
                                data={chartData}
                                margin={{ top: 5, right: 30, left: 20, bottom: 40 }}
                            >
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis
                                    dataKey="period"
                                    angle={-30}
                                    textAnchor="end"
                                    interval={0}
                                    tick={{ fontSize: 11 }}
                                />
                                <YAxis />
                                <Tooltip
                                    formatter={(value) => [parseFloat(value).toLocaleString(), 'Count']}
                                />
                                <Legend />
                                <Bar dataKey="count" name="Count" fill="#8884d8" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SubCountReportTable;
